import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import React__default from 'react';
import { Button } from '../../Button/index.js';
import { Footer } from '../../shared/Footer/index.js';
import { ModalHeader } from '../../shared/Header/index.js';
import { Text } from '../../Text/index.js';
import { OverlayBase, ContainerWrapper, ContainerBase } from '../shared/styles.js';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';

const Root = ({
  children,
  onClose,
  ...props
}) => jsx(AlertDialogPrimitive.Root, {
  onOpenChange: open => {
    if (!open) {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  },
  ...props,
  children: children
});
const Portal = AlertDialogPrimitive.Portal;
const Container = React__default.forwardRef(({
  children,
  ...props
}, ref) => jsxs(Fragment, {
  children: [jsx(OverlayBase, {
    as: AlertDialogPrimitive.Overlay
  }), jsx(ContainerWrapper, {
    as: AlertDialogPrimitive.Overlay,
    children: jsx(ContainerBase, {
      ref: ref,
      as: AlertDialogPrimitive.Content,
      "data-variant": "alert",
      style: {
        '--transform-origin': 'center center'
      },
      ...props,
      children: children
    })
  })]
}));
const Title = props => jsx(AlertDialogPrimitive.Title, {
  asChild: true,
  children: jsx(Text.Heading, {
    ...props,
    size: "md"
  })
});
const Description = props => jsx(AlertDialogPrimitive.Description, {
  asChild: true,
  children: jsx(Text.Body, {
    ...props,
    size: "sm",
    as: "div"
  })
});
const Cancel = ({
  children,
  ...props
}) => jsx(AlertDialogPrimitive.Cancel, {
  asChild: true,
  children: jsx(Button.Tertiary, {
    ...props,
    children: children
  })
});
const Action = ({
  destructive = false,
  children,
  ...props
}) => jsx(AlertDialogPrimitive.Action, {
  asChild: true,
  children: jsx(Button.Primary, {
    tone: destructive ? 'negative' : 'neutral',
    ...props,
    children: children
  })
});
const Trigger = ({
  children,
  ...props
}) => jsx(AlertDialogPrimitive.Trigger, {
  asChild: true,
  ...props,
  children: children
});
const Header = ModalHeader;
const Alert = Object.assign(Root, {
  Trigger,
  Header,
  Footer,
  Portal,
  Container,
  Cancel,
  Action,
  Title,
  Description,
  displayName: 'Alert'
});

export { Alert };
